import React from 'react'

import Layout from '../layout/layout'
import Seo from "../layout/seo"
import { StaticImage } from 'gatsby-plugin-image';

import './styles/training.scss';


const training = ({data}) => {
    
    
    
    return (
        <Layout title="Pre-conference Developer Training" >
            <Seo title="Pre-conference Developer Training" />
            <div className="container" >
                <p style={{marginTop: `3.5rem`}}>Pre-conference Training Sessions are conducted by GridGain engineers and solution architects with deep technical expertise and real-world experience solving customer problems. During the sessions, attendees will use the actual products, and learn how to unlock the full potential of the Ignite platform.</p> 
                <p>After the training sessions attendees will receive special badges so they can share their Apache Ignite proficiency with peers and prospective employers.</p>
                <p>Please click on the links below to join us at a future training sessions:</p>
                <ul style={{paddingLeft: `1rem`}}>
                    <li><a href="#apache-ignite-kubernetes">Apache Ignite and Kubernetes: Deployment and Orchestration Strategies</a></li>
                    <li><a href="#apache-ignite-essentials">Apache Ignite Essentials: Key Design Principles for Building Data-Intensive Applications</a></li>
                    <li><a href="#apache-ignite-spring-boot">Apache Ignite for Spring Boot and Spring Data Development</a></li>
                    <li><a href="#apache-ignite-monitor-manage">How to Monitor and Manage Apache Ignite With GridGain Control Center</a></li>
                    </ul>

                <article className="training-session" id="apache-ignite-kubernetes" >
                    <header>
                        <div className="img-wrapper"><StaticImage alt="Denis Magda picture" src="../images/training-instructors/denis-magda.jpg"  /></div>
                        <div className="txt-wrapper">
                            <h2>Apache Ignite and Kubernetes: Deployment and Orchestration Strategies</h2>
                            
                            <div className="instructor">
                                <strong>Instructor:</strong> <span>Denis Magda - <i>VP, Developer Relations in R&D at GridGain; Apache Ignite committer and PMC member</i></span>
                            </div>
                            <div className="instructor">
                                <strong>Price:</strong> <span>Free</span>
                            </div>
                            <div className="instructor">
                                <strong>Time:</strong> <span>15 November - 11:00 am, PT (AMERICAS)</span>
                            </div>
                        </div>
                    </header>
                    <div className="description">
                        <p>This two-hour training is for developers, architects, and DevOps engineers who want to deploy and orchestrate Apache Ignite in a Kubernetes environment. You begin with the configuration and scalability essentials, as you deploy Ignite in pure in-memory mode. Next, you convert the Ignite in-memory cluster into a multitier database that scales beyond available memory capacity, as you set up disk storage for Ignite native persistence and GridGain backups. Finally, you select the connectivity option that is preferred for your applications and simplify the monitoring, management, and troubleshooting of your Kubernetes-based deployment.</p>
    
                        <h4>Training Topics:</h4>
                        <ul>
                            <li>Ignite in in-memory mode: basic configuration principles, cluster discovery, auto-scaling, availability zones, and rolling restarts</li>
                            <li>Ignite in multitier database mode (in-memory plus native persistence): storage configuration (data versus WAL), cluster backups, and storage performance monitoring</li>
                            <li>Application deployment and connectivity options: apps and Ignite in K8, apps in K8 but Ignite outside, and Ignite in K8 but apps outside</li>
                        </ul>

                        <h4>Recommendation:</h4>
                        <p>If you are new to Ignite, attend the Apache Ignite Essentials course: <a href="https://www.gridgain.com/products/services/training/apache-ignite-essentials" target="_blank" rel="noreferrer">https://www.gridgain.com/products/services/training/apache-ignite-essentials</a></p>

                        <div className="cta"><a href="https://www.gridgain.com/training/register/apache-ignite-and-kubernetes-deployment-and-orchestration-strategies-11152021" target="_blank" rel="noreferrer" className="rounded-button">Register</a></div>
                    </div>
                </article>

                <article className="training-session" id="apache-ignite-essentials" >
                    <header>
                        <div className="img-wrapper"><StaticImage alt="Stephen Darlington picture" src="../images/training-instructors/Stephen_Darlington.jpg"  /></div>
                        <div className="txt-wrapper">
                            <h2>Apache Ignite Essentials: Key Design Principles for Building Data-Intensive Applications</h2>
                            
                            <div className="instructor">
                                <strong>Instructor:</strong> <span>Stephen Darlington - <i>Senior Consultant at GridGain</i></span>
                            </div>
                            <div className="instructor">
                                <strong>Price:</strong> <span>Free</span>
                            </div>
                            <div className="instructor">
                                <strong>Time:</strong> <span>15 November - 8:00 am, GMT (EMEA/APAC)</span>
                            </div>
                        </div>
                    </header>
                    <div className="description">
                        <p>This two-hour training is for Java developers and architects who build high-performance and data-intensive applications that are powered by Apache Ignite. During the course, you are introduced to three of Ignite's essential capabilities (data partitioning, affinity co-location, and co-located processing) and learn how to apply your newly acquired knowledge to increase the speed and scale of your applications.</p>

                        <h4>Training Topics:</h4>
                        <ul>
                            <li>The essential capabilities of Apache Ignite</li>
                            <li>How to use data partitioning to achieve limitless horizontal scalability</li>
                            <li>How affinity co-location of data makes it possible to run high-performance, distributed queries at scale</li>
                            <li>How to run custom compute tasks straight on the cluster nodes, to negate any negative impact that a network might have on the performance of your applications.</li>
                        </ul>

                        <div className="cta"><a href="https://www.gridgain.com/training/register/apache-ignite-essentials-key-design-principles-building-data-intensive-2" target="_blank" rel="noreferrer" className="rounded-button">Register</a></div>
                    </div>
                </article>
            

                <article className="training-session" id="apache-ignite-spring-boot" >
                    <header>
                        <div className="img-wrapper"><StaticImage alt="Semyon Danilov picture" src="../images/training-instructors/Semyon_Danilov.jpg"  /></div>
                        <div className="txt-wrapper">
                            <h2>Apache Ignite for Spring Boot and Spring Data Development</h2>
                            
                            <div className="instructor">
                                <strong>Instructor:</strong> <span>Semyon Danilov - <i>Software Engineer at GridGain</i></span>
                            </div>
                            <div className="instructor">
                                <strong>Price:</strong> <span>Free</span>
                            </div>
                            <div className="instructor">
                                <strong>Time:</strong> <span>15 November - 10:00 am, GMT (EMEA/APAC)</span>
                            </div>
                        </div>
                    </header>
                    <div className="description">
                        <p>This two-hour training is for Java developers and architects who want to explore the best practices and nuances of using Spring Boot and Spring Data with Apache Ignite. During the training, you build a RESTful web service that uses Apache Ignite as an in-memory database. The service is a Spring Boot application that interacts with the Ignite cluster via Spring Data repository abstractions.</p>

                        <h4>Training Topics:</h4>
                        <ul>
                            <li>Configuring an Apache Ignite cluster that uses Spring Boot and Spring Data</li>
                            <li>Designing Java POJOs for Ignite Spring Data repositories</li>
                            <li>Defining custom SQL queries for Ignite Spring Data repositories</li>
                            <li>Designing DTOs (data transfer objects) for Ignite Spring Data services</li>
                            <li>Building a Spring Boot RESTful endpoint that works with Ignite Spring Data services</li>
                            <li>Learning tips and tricks while working with Ignite Spring Data and Ignite Spring Boot</li>
                        </ul>

                        <div className="cta"><a href="https://www.gridgain.com/training/register/apache-ignite-spring-boot-and-spring-data-development-11152021" target="_blank" rel="noreferrer" className="rounded-button">Register</a></div>
                    </div>
                </article>



                <article className="training-session" id="apache-ignite-monitor-manage" >
                    <header>
                        <div className="img-wrapper"><StaticImage alt="Greg Stachnick picture" src="../images/training-instructors/greg-stachnick.jpg"  /></div>
                        <div className="txt-wrapper">
                            <h2>How to Monitor and Manage Apache Ignite With GridGain Control Center</h2>
                            
                            <div className="instructor">
                                <strong>Instructor:</strong> <span>Greg Stachnick - <i>Director of Product Management at GridGain</i></span>
                            </div>
                            <div className="instructor">
                                <strong>Price:</strong> <span>Free</span>
                            </div>
                            <div className="instructor">
                                <strong>Time:</strong> <span>15 November - 9:00 am, PT (AMERICAS)</span>
                            </div>
                        </div>
                    </header>
                    <div className="description">
                        <p>This two-hour, hands-on training is for those wondering how to monitor and manage Apache Ignite clusters in production: what the most important metrics are, how to set up alerting or troubleshoot performance when the cluster is under the production load, and develop queries. The list of questions and challenges related to Ignite production monitoring goes on and on. And you’ll get many of those questions covered.</p>
                        
                        <p>During the training, you’re going to set up a management and monitoring solution based on GridGain Control Center, an enterprise-grade tool for Ignite deployments. The solution will let you perform or automate the following tasks:</p>

                        <ul>
                            <li>Ignite storage monitoring - includes but not limited to the memory and disk usage, checkpointing, and WAL-related I/O monitoring</li>
                            <li>Alerts configuration and triggering - to ensure that you are notified when a crucial cluster event occurs</li>
                            <li>Distributed tracing usage - to detect and solve bottlenecks or hot spots in operations that span multiple cluster nodes</li>
                            <li>Query development and tips to analyze query performance statistics</li>
                        </ul>

                        <div className="cta"><a href="https://www.gridgain.com/training/register/how-monitor-and-manage-apache-ignite-gridgain-control-center-11152021" target="_blank" rel="noreferrer" className="rounded-button">Register</a></div>
                    </div>
                </article>



                

            </div></Layout>
        
    )
}

export default training
